import { render, staticRenderFns } from "./DepartmentManager.vue?vue&type=template&id=6952b78f&"
import script from "./DepartmentManager.vue?vue&type=script&lang=js&"
export * from "./DepartmentManager.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentManager.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports